var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var Logo = function (props) { return (_jsxs("svg", __assign({ width: "96", height: "96", viewBox: "0 0 96 96", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props, { children: [_jsxs("g", __assign({ clipPath: "url(#clip0)" }, { children: [_jsx("circle", { cx: "48", cy: "48", r: "48", fill: "#FF385C" }, void 0), _jsx("path", { d: "M3 71.9068L47.8065 25L71.61 49.5036L47.5 75.5", stroke: "white", strokeWidth: "6", strokeLinecap: "square" }, void 0)] }), void 0), _jsx("defs", { children: _jsx("clipPath", __assign({ id: "clip0" }, { children: _jsx("rect", { width: "96", height: "96", rx: "48", fill: "white" }, void 0) }), void 0) }, void 0)] }), void 0)); };
export default Logo;
//# sourceMappingURL=logo.js.map